import React, { useEffect } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { Link } from 'react-router-dom';
function AwardsHonours() {
  useEffect(() => {
    document.title = '   Awards & Honours -  CARMEL CONVENT SCHOOL, DHARUHERA';
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>   Awards & Honours</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">   Awards & Honours</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">

              <div className="achievement-card">

                <h3 className="mb-2">
                  5TH LAXMI DEVI MEMORIAL INVITATIONAL (STATE LEVEL) TAEKWONDO CHAMPIONSHIP
                </h3>

                <p className="mb-4">
                  held on 25th April 2026, in Rewari
                </p>

                <div className="table-responsive maintable">
                  <table className="table table-bordered align-middle">
                    <thead>
                      <tr>
                        <th>Class</th>
                        <th>Name</th>
                        <th>Winner</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>I</td>
                        <td>Vedant</td>
                        <td>Gold</td>
                      </tr>
                      <tr>
                        <td>II</td>
                        <td>Devansh</td>
                        <td>Gold</td>
                      </tr>
                      <tr>
                        <td>V</td>
                        <td>Vanshika</td>
                        <td>Gold</td>
                      </tr>
                      <tr>
                        <td>V</td>
                        <td>Jaishika Singh</td>
                        <td>Gold</td>
                      </tr>
                      <tr>
                        <td>V</td>
                        <td>Angel Tirkey</td>
                        <td>Gold</td>
                      </tr>
                      <tr>
                        <td>VI</td>
                        <td>Daksh Chakradhar</td>
                        <td>Gold</td>
                      </tr>
                      <tr>
                        <td>VI</td>
                        <td>Paras</td>
                        <td>Gold</td>
                      </tr>
                      <tr>
                        <td>V</td>
                        <td>Ashish Burh</td>
                        <td>Gold</td>
                      </tr>
                      <tr>
                        <td>III</td>
                        <td>Nihira Yadav</td>
                        <td>Silver</td>
                      </tr>
                      <tr>
                        <td>I</td>
                        <td>Kiara Khatri</td>
                        <td>Silver</td>
                      </tr>
                      <tr>
                        <td>II</td>
                        <td>Garima Bishnoi</td>
                        <td>Silver</td>
                      </tr>
                      <tr>
                        <td>III</td>
                        <td>Varen</td>
                        <td>Silver</td>
                      </tr>
                      <tr>
                        <td>V</td>
                        <td>Daksh Khatri</td>
                        <td>Bronze</td>
                      </tr>
                      <tr>
                        <td>II</td>
                        <td>Ronav</td>
                        <td>Bronze</td>
                      </tr>
                      <tr>
                        <td>IV</td>
                        <td>Urmik</td>
                        <td>Bronze</td>
                      </tr>
                      <tr>
                        <td>VI</td>
                        <td>Ansh</td>
                        <td>Bronze</td>
                      </tr>
                      <tr>
                        <td>III</td>
                        <td>Prince Yadav</td>
                        <td>Bronze</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

            </div>
          </div>
          <br/>
          <div className="row">
            <div className="col-lg-12">

              <div className="achievement-card">

                <h3 className="mb-2">
                  1st Veer Bharat Open National Taekwondo Championship
                </h3>

                <p className="mb-4">
                  organized by KTC Kotdwar, Distt: Pauri Garwal (UK) held on 01.06.2026
                </p>

                <div className="table-responsive maintable">
                  <table className="table table-bordered align-middle">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Class</th>
                        <th>Winner</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Rishabh</td>
                        <td>Class 4</td>
                        <td>🥇</td>
                      </tr>
                      <tr>
                        <td>Kiara</td>
                        <td>Class 1</td>
                        <td>🥇</td>
                      </tr>
                      <tr>
                        <td>Om singh</td>
                        <td>Class U.kg</td>
                        <td>🥇</td>
                      </tr>
                      <tr>
                        <td>Prince Yadav</td>
                        <td>Class 3</td>
                        <td>🥇</td>
                      </tr>
                      <tr>
                        <td>Jaishika</td>
                        <td>Class 5</td>
                        <td>🥈</td>
                      </tr>
                      <tr>
                        <td>Varen Yadav</td>
                        <td>Class 3</td>
                        <td>🥈</td>
                      </tr>
                      <tr>
                        <td>Paras</td>
                        <td>Class 6</td>
                        <td>🥈</td>
                      </tr>
                      <tr>
                        <td>Ansh</td>
                        <td>Class 6</td>
                        <td>🥈</td>
                      </tr>
                      <tr>
                        <td>Ishant</td>
                        <td>Class 6</td>
                        <td>🥉</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div className="row g-4 justify-content-center">
            <div className="col-md-6">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Awards-1.png"
                className="img-fluid w-100 rounded shadow-sm lazyload"
                alt="CBSE"
              />
            </div>
            <div className="col-md-6">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Awards-2.jpg"
                className="img-fluid w-100  rounded shadow-sm lazyload"
                alt="CBSE"
              />
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </>
  )
}

export default AwardsHonours